var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('b-navbar-nav',_vm._l((_vm.items),function(item,index){return _c('b-nav-item',{key:index,attrs:{"to":item.to}},[_vm._v(" "+_vm._s(item.content.toUpperCase())+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }